// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailSeparator_container_1ijFZ","label":"DetailSeparator_label_1d2B5","mandatory":"DetailSeparator_mandatory_OauFB"};